import { Component, Input } from '@angular/core';
import { DynacFormFieldModel } from 'src/app/interfaces/interfaces';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
	selector: 'app-dynamic-form-field',
	templateUrl: './dynamic-form-field.component.html',
	styleUrls: ['./dynamic-form-field.component.scss']
})
export class DynamicformFieldComponent {

	@Input() formItem!: DynacFormFieldModel;
	@Input() type!: DynacFormFieldModel['type'];

	form!: FormGroup;

	constructor(private rootFormGroup: FormGroupDirective) {
		this.form = this.rootFormGroup.control;
	}
}